import React from 'react';
import { AHLevelProvider } from './AccessibleHeading';

interface TermsHtmlContentProps {
  htmlContent: string;
}

/**
 * Renders HTML content for terms/privacy documents with proper accessibility support.
 * The HTML should already contain semantic markup (headings, lists, paragraphs, etc.).
 */
const TermsHtmlContent = ({ htmlContent }: TermsHtmlContentProps) => (
  <AHLevelProvider>
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  </AHLevelProvider>
);

export default TermsHtmlContent;
